import types from '@/store/mutation-types'
import Vue from 'vue'

const defaultState = getDefaultState()

function getDefaultState () {
  return { pageLevel: false }
}

// getters
const getters = {
  isPageDirty: state => state && Object.values(state).some(val => val),
  dirtyComponents: state => state,
}

// mutations
const mutations = {
  [types.FORM_UPDATE] (state, { isDirty = false, src }) {
    let dirtySrc = 'pageLevel'
    if (src) {
      dirtySrc = src
    }
    Vue.set(state, dirtySrc, isDirty)
  },
  [types.RESET_STATE] (state) {
    for (const field in state) {
      Vue.set(state, field, false)
    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
}
